import { render, staticRenderFns } from "./DomainPostingTable.vue?vue&type=template&id=f40f425c&"
import script from "./DomainPostingTable.vue?vue&type=script&lang=js&"
export * from "./DomainPostingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports